import MigrationWarning from "../../../../contents/docs/migrate/_snippets/migration-warning.mdx";
import * as React from 'react';
export default {
  MigrationWarning,
  React
};